import Icon from '../../../components/AppIcon';

const DisputeResolutionPanel = ({ onRefresh }) => {
  // Placeholder component - no disputes table exists yet
  const mockDisputes = [];

  return (
    <div className="bg-card rounded-lg shadow-md border border-border overflow-hidden">
      <div className="p-6 border-b border-border">
        <h2 className="text-xl font-semibold text-foreground flex items-center gap-2">
          <Icon name="AlertTriangle" size={24} />
          Dispute Resolution Center
        </h2>
        <p className="text-sm text-muted-foreground mt-1">
          Manage disputes between users, track resolution status, and mediate conflicts
        </p>
      </div>

      <div className="p-12 text-center">
        <Icon name="Shield" size={64} className="mx-auto text-muted-foreground mb-4" />
        <h3 className="text-lg font-semibold text-foreground mb-2">Dispute System Coming Soon</h3>
        <p className="text-muted-foreground max-w-md mx-auto">
          The dispute resolution system is currently under development. This feature will allow administrators to manage conflicts between users, track resolution progress, and maintain platform integrity.
        </p>
        <div className="mt-6 grid grid-cols-1 md:grid-cols-3 gap-4 max-w-2xl mx-auto">
          <div className="p-4 bg-muted/50 rounded-lg">
            <Icon name="FileText" size={32} className="mx-auto text-primary mb-2" />
            <p className="text-sm font-medium text-foreground">Case Management</p>
            <p className="text-xs text-muted-foreground mt-1">Track and manage dispute cases</p>
          </div>
          <div className="p-4 bg-muted/50 rounded-lg">
            <Icon name="MessageSquare" size={32} className="mx-auto text-accent mb-2" />
            <p className="text-sm font-medium text-foreground">Mediation Tools</p>
            <p className="text-xs text-muted-foreground mt-1">Communicate with involved parties</p>
          </div>
          <div className="p-4 bg-muted/50 rounded-lg">
            <Icon name="CheckCircle" size={32} className="mx-auto text-success mb-2" />
            <p className="text-sm font-medium text-foreground">Resolution Tracking</p>
            <p className="text-xs text-muted-foreground mt-1">Monitor resolution progress</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DisputeResolutionPanel;